import * as React from 'react'

import { SafeHtml } from '@thg-commerce/gravity-elements'

export interface SignoffProps {
  content: string
  isAmp: boolean
}

export const Signoff = (props: SignoffProps) => {
  return <SafeHtml content={props.content} />
}
